import React from 'react';
import { DoodleBurst, DoodleHeart, DoodleStar } from '../brand/Doodles';
import type { BcmLeader } from '../../data/leadership';
const accents = ['bg-brand-blue', 'bg-brand-yellow', 'bg-brand-tan', 'bg-brand-pink'] as const;
function Shape({
  index
}: {
  index: number;
}) {
  const which = index % 3;
  if (which === 0) return <DoodleStar className="h-8 w-8" color="var(--bcm-dark-blue)" data-id="element-22" data-mp="3ovg67p19ler2" />;
  if (which === 1) return <DoodleBurst className="h-8 w-8" color="var(--bcm-dark-blue)" data-id="element-23" data-mp="2s709n8zqm54g" />;
  return <DoodleHeart className="h-8 w-8" color="var(--bcm-dark-blue)" data-id="element-24" data-mp="2w7k94j7s9ktr" />;
}

/**
 * Branded role card. When `leader.photo` is supplied the real photo replaces the
 * initials placeholder — no stock headshots or generated faces are ever used.
 */
export function LeaderCard({
  leader,
  index
}: {
  leader: BcmLeader;
  index: number;
}) {
  return <article className="flex h-full flex-col overflow-hidden rounded-[20px] border-2 border-brand-navy bg-white transition-transform duration-200 hover:-translate-y-1" data-id="element-25" data-mp="gfwdqs8f40d2">
      {leader.photo ? <img src={leader.photo} alt={`${leader.name}, ${leader.role} at UCF BCM`} loading="lazy" className="aspect-square w-full border-b-2 border-brand-navy object-cover" data-id="element-26" data-mp="vxpowa3uwu5l" /> : <div className={`flex aspect-square w-full flex-col items-center justify-center gap-2 border-b-2 border-brand-navy ${accents[index % accents.length]}`} data-id="element-27" data-mp="n05pl6pk17xm">
          <span aria-hidden="true" data-id="element-28" data-mp="d1zkyhcd5np2">
            <Shape index={index} data-id="element-29" data-mp="88n08iat211l" />
          </span>
          <span className="px-2 text-center font-meta text-[12.5px] font-semibold text-brand-navy" data-id="element-30" data-mp="87vcturd39me">
            Add Image here
          </span>
        </div>}
      <div className="p-5" data-id="element-31" data-mp="3vexg8ay7nscw">
        <h3 className="font-display text-lg font-bold leading-snug text-brand-navy" data-id="element-32" data-mp="3vfpczp3jnw4r">
          {leader.name}
        </h3>
        <p className="mt-1 font-meta text-[12px] font-semibold uppercase tracking-[0.14em] text-ink" data-id="element-33" data-mp="3qgm7k3jnjnw9">
          {leader.role}
        </p>
      </div>
    </article>;
}